
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { RegionResponse } from "../../models/dtos";

export const regionsApi = createApi({
  reducerPath: 'regionsApi',
  baseQuery: baseAuthQuery('Regions'),
  tagTypes: ['Region'],
  endpoints: (builder) => ({
    getRegions: builder.query<ApiResponse<RegionResponse[]>, void>({
      query: () => "",
      providesTags: ['Region'],
    }),
    getRegionById: builder.query<ApiResponse<RegionResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Region'],
    }),
    updateRegion: builder.mutation<ApiResponse<RegionResponse>, Partial<RegionResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['Region'],
    }),
    deleteRegion: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['Region'],
    }),
  }),
});
